import { CloseOutlined } from '@ant-design/icons';
import { Button, Spinner } from '@mm/components';
import {
  IGoogleSheetPickerProps,
  IGoogleSpreadsheetModal,
} from '@mm/state/modules/modalsState/props';
import classNames from 'classnames';
import React, { useState } from 'react';
import { GoogleSheetPickerForm } from '@mm/stateful-components/ContactsExportModal/GoogleSheetPickerForm/GoogleSheetPickerForm';
import css from './GoogleSpreadsheetModal.module.css';

export const GoogleSpreadsheetModal: React.FC<IGoogleSpreadsheetModal> = ({
  className,
  onReject = () => {},
  onSubmit = async () => {},
}) => {
  const [googleSheetProps, setGoogleSheetProps] =
    useState<IGoogleSheetPickerProps>();

  const [busy, setBusy] = useState(false);

  const isSubmitDisabled = !googleSheetProps?.sheet || busy;

  const handleReject = () => onReject();
  const handleSubmit = async () => {
    if (
      googleSheetProps?.sheet &&
      googleSheetProps.spreadsheet &&
      googleSheetProps.account
    ) {
      setBusy(true);
      try {
        await onSubmit(googleSheetProps);
      } finally {
        setBusy(false);
      }
    }
  };

  return (
    <div className={classNames(className, css.container)}>
      <div className={classNames(css.modal, { [css.error]: false })}>
        <div className={css.modalContent}>
          <span className={css.close} onClick={handleReject}>
            <CloseOutlined />
          </span>
          <h1 className={css.title}>
            Add Google Sheet
            <span className={css.subtitle}>Set up your worksheet</span>
          </h1>

          <GoogleSheetPickerForm
            setGoogleSheetProps={setGoogleSheetProps}
            withLookupColumnSelect
          />
          <div className={css.actions}>
            <Button
              color="transparent-no-shadow"
              onClick={handleReject}
              size="lg"
              css={{ container: css.cancelButton }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              size="lg"
              disabled={isSubmitDisabled}
              rightIcon={
                busy && (
                  <Spinner
                    show={busy}
                    position="relative"
                    size={13}
                    color="white"
                    backgroundColor="transparent"
                  />
                )
              }
            >
              Connect
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
